import { render, staticRenderFns } from "./LabelSetup.vue?vue&type=template&id=0a031307&scoped=true"
import script from "./LabelSetup.vue?vue&type=script&lang=ts"
export * from "./LabelSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a031307",
  null
  
)

export default component.exports